import { render, staticRenderFns } from "./reply-msg-list.vue?vue&type=template&id=f924948c&scoped=true&"
import script from "./reply-msg-list.vue?vue&type=script&lang=js&"
export * from "./reply-msg-list.vue?vue&type=script&lang=js&"
import style0 from "./reply-msg-list.vue?vue&type=style&index=0&id=f924948c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f924948c",
  null
  
)

export default component.exports